import { __awaiter, __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { forkJoin } from "rxjs";
//Services
import { RemoteConfigService } from "../remote-config/remote-config.service";
import { UniteObjectsService } from "../uniteObjects/unite-objects.service";
let LanguagesService = class LanguagesService {
    constructor(remoteConfigService, uniteObjectsService) {
        // this.language = this.remoteConfigService.languageDefault;
        this.remoteConfigService = remoteConfigService;
        this.uniteObjectsService = uniteObjectsService;
        this.language = "es"; //TODO: falta enlazar esta varible a al cambiar idioma
        //this.loadLanguage();
    }
    loadLanguage(lang) {
        return __awaiter(this, void 0, void 0, function* () {
            forkJoin(this.remoteConfigService.getLanguage('es'), // textsIU
            this.remoteConfigService.getRoutes(), // routes
            this.remoteConfigService.getSettingsMenu(), // settings menu
            this.remoteConfigService.getOnBoarding(), // data onboarding
            this.remoteConfigService.getSettingsPageHome(), // settings page home
            this.remoteConfigService.getSetingsTabs(), // settings tabs
            this.remoteConfigService.getLoginChat(), this.remoteConfigService.getSettingsCategoryContent(), // settings category content
            this.remoteConfigService.getSettingsMenuWeb() // settings menu
            ).subscribe((response) => {
                this.uniteObjectsService.addParameters(response);
                //console.log("+lx,",response);
                this.textsIU = response[0];
                //console.log("+lg,",this.textsIU );
            }, (error) => console.log("error al cargar configuraciones de remote config", error));
        });
    }
    changeLanguage(language) {
        // --->>> active next line
        this.language = language;
        // this.language = language === "es" ? "es" : "en";
        switch (this.language) {
            case "es":
                this.loadLanguage("es");
                break;
            case "en":
                this.loadLanguage("en");
                break;
            default:
                break;
        }
    }
    get loadedLanguage() {
        if (this.textsIU)
            return true;
        return false;
    }
    check(setting, name) {
        // console.log(setting, name);
        return setting.active === true && setting.name === name;
    }
    sortSettings(settings) {
        Object.keys(settings).map((label) => {
            if (Array.isArray(label)) {
                settings[label].sort((a, b) => a.order - b.order);
            }
        });
        return settings;
    }
};
LanguagesService.ctorParameters = () => [
    { type: RemoteConfigService },
    { type: UniteObjectsService }
];
LanguagesService = __decorate([
    Injectable({
        providedIn: "root",
    })
], LanguagesService);
export { LanguagesService };
//# sourceMappingURL=languages.service.js.map